<template>
  <div id="user">
    <van-card
      :thumb="vipinfo.avatar"
      @click-thumb="avatarClick">
      <div slot="title">
        {{ vipinfo.user_name }}
      </div>
      <div slot="desc">
        <br/>
        {{ vipinfo.vip_phone }}
      </div>
      <div slot="tags" class="tags">
        <van-tag plain type="danger">{{ vipinfo.grade_name }}</van-tag>
        <van-tag plain type="success" @click="carshow=true">{{ vipinfo.car_code }}</van-tag>
      </div>
      <div slot="price">
        <span>{{ vipinfo.address }}</span>
      </div>
      <div slot="num">
        <div class="msg" @click="tomsg"><van-icon name="chat">消息</van-icon></div> 
      </div>
      <div slot="footer"/>
    </van-card>
    <van-tabbar :fixed="false"  v-model="activate">
      <van-tabbar-item icon="pending-payment" to="/user/orders/0" :info="newcount + waitcount">待提货</van-tabbar-item>
      <van-tabbar-item icon="records"  to="/user/orders/1">已提货</van-tabbar-item>
      <!-- <van-tabbar-item icon="logistics"  to="/user/orders/2" :info="waitcount">配货中</van-tabbar-item> -->
      <van-tabbar-item icon="tosend" to="/user/orders/9">已取消</van-tabbar-item>
    </van-tabbar>

    <van-loading v-if="loading" vertical/>
    <van-cell-group class="user-group">
      <van-cell icon="records" title="全部订单" is-link to="/user/orders/100" />
    </van-cell-group>

    <van-cell-group>
      <van-cell icon="points" title="我的积分" is-link />
      <van-cell icon="gold-coin-o" title="我的储值卡" is-link to="/user/storedcard"/>
      <van-cell icon="gold-coin-o" title="我的优惠券" is-link to="/user/coupons"/>
      <van-cell icon="gift-o" title="我的兑换券" is-link to="/user/vouchers" />
    </van-cell-group>

    <van-popup
      v-model="carshow"
      closeable
      position="bottom"
      :style="{ height: '50%' }">
      <van-address-list
        v-model="vipinfo.car"
        :list="vipinfo.cars"
        default-tag-text="Default"
        add-button-text='增加爱车'
        @select="selCar"
        @add="addCar"
        @edit="editCar"/>
    </van-popup>
    <AddCar ref="addcar"/>
  </div>
</template>

<script>
import { Row, 
  Col, 
  Icon, 
  Cell, 
  CellGroup, 
  Tabs, 
  Tab, 
  Tabbar, 
  TabbarItem, 
  Loading, 
  Toast, 
  Tag,
  Card, 
  Button,
  Popup,
  AddressList } from 'vant';
import { OrderItemApi, VipApi } from '@/api/market'
import AddCar from '@/view/user/components/addcar'

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Loading.name]: Loading,
    [Card.name]: Card,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [AddressList.name]: AddressList,
    AddCar
  },
  data() {
    return {
      activate: null,
      carshow: false,
      loading: false,
      newcount: null,
      waitcount: null,
      vipinfo: {
        shop: null,
        user: null,
        shop_name: null,
        user_name: null,
        grade: null,
        grade_name: null,
        phone: null,
        car_code: '',
        car: null,
        cars: [],
        available_score: null,
        total_consumption: null,
        vip_address: null,
        vip_email: null,
        sex: null,
        avatar: null
      },
    }
  },
  mounted() {
    this.getData()
    this.getVipInfo()
  },
  methods: {
    getVipInfo() {
      var that = this
      that.axios.get(VipApi).then((ret) => {
        console.log('huiyuanxinxi')
        console.log(ret)
        if (ret.flag) {
          that.vipinfo = ret.details
          const cars = []
          that.vipinfo.cars.forEach((it) => {
            cars.push({
              id: it.id,
              tel: '',
              name: it.code,
              address: it.name
            })
          })
          that.vipinfo.cars = cars
        }
      })
    },
    getData() {
      var that = this
      that.loading = true
      const paras = {
        style: 'count'
      }
      that.axios.get(OrderItemApi, { params: paras}).then((ret) => {
        console.log(ret)
        that.loading = false
        if (ret.flag) {
          if (ret.details.newcount > 0) {
            that.newcount = ret.details.newcount
          }
          if (ret.details.waitcount > 0) {
            that.waitcount = ret.details.waitcount
          }
        } else {
          Toast(ret.info)
        }
      })
    },
    avatarClick() {
      Toast('个人信息')
    },
    tomsg() {
      Toast('waiting')
    },
    selCar(item) {
      this.vipinfo.car = item.id
      this.vipinfo.car_code = item.name
      this.carshow = false
    },
    addCar() {
      this.carshow = false
      this.$refs.addcar.add()
    },
    editCar(_, index) {
      Toast('编辑')
      console.log('editCar')
      console.log(index)
    }
  }
};
</script>

<style>
.van-address-item__edit {
    display: none;
}
</style>

<style lang="less">
#user {
  &-poster {
    width: 100%;
    height: 53vw;
    display: block;
  }

  &-group {
    margin-bottom: 15px;
  }

  &-links {
    padding: 15px 0;
    font-size: 12px;
    text-align: center;
    background-color: #fff;

    .van-icon {
      display: block;
      font-size: 24px;
    }
  }

  .tags {
    .van-tag {
      margin-right: 4px;
    }
  }

  .msg {
    color: #1989fa;
  }

  .van-card__footer {
    text-align: center;
    display: flex;
  }
}
</style>
